import { createConfig, http } from 'wagmi';
import { coinbaseWallet, injected } from 'wagmi/connectors';

// Import all chains from centralized chains.js
import {
  mainnet,
  sepolia,
  arbitrum,
  arbitrumSepolia,
  apeChain,
  curtis,
  base,
  baseSepolia,
  abstract,
  abstractTestnet,
  ENERGI_MAINNET,
  ENERGI_TESTNET,
  MONAD_MAINNET,
  MONAD_TESTNET,
  BINANCE_MAINNET,
  BINANCE_TESTNET,
} from 'constants/chains';

const wagmiConfig = createConfig({
  chains: [
    mainnet,
    sepolia,
    arbitrum,
    arbitrumSepolia,
    apeChain,
    curtis,
    base,
    baseSepolia,
    abstract,
    abstractTestnet,
    ENERGI_MAINNET,
    ENERGI_TESTNET,
    MONAD_MAINNET,
    MONAD_TESTNET,
    BINANCE_MAINNET,
    BINANCE_TESTNET,
  ],
  connectors: [
    injected(),
    coinbaseWallet({
      appName: 'GonnaMakeIt NFT Marketplace',
    }),
  ],
  transports: {
    [mainnet.id]: http('https://eth-mainnet.public.blastapi.io'),
    [sepolia.id]: http('https://eth-sepolia.public.blastapi.io'),
    [arbitrum.id]: http('https://arb1.arbitrum.io/rpc'),
    [arbitrumSepolia.id]: http('https://sepolia-rollup.arbitrum.io/rpc'),
    [apeChain.id]: http('https://apechain.calderachain.xyz/http'),
    [curtis.id]: http('https://curtis.rpc.caldera.xyz/http'),
    [base.id]: http('https://base-rpc.publicnode.com'),
    [baseSepolia.id]: http('https://base-sepolia-rpc.publicnode.com'),
    [abstract.id]: http('https://api.mainnet.abs.xyz'),
    [abstractTestnet.id]: http('https://api.testnet.abs.xyz'),
    [ENERGI_MAINNET.id]: http(),
    [ENERGI_TESTNET.id]: http(),
    [MONAD_MAINNET.id]: http('https://rpc.monad.xyz'),
    [MONAD_TESTNET.id]: http('https://testnet-rpc.monad.xyz'),
    [BINANCE_MAINNET.id]: http('https://bsc-rpc.publicnode.com'),
    [BINANCE_TESTNET.id]: http('https://bsc-testnet.drpc.org'),
  },
});

export default wagmiConfig;
